import { useEffect, useState } from 'react'
import { SmartDialog } from '../../../generic/utilities/SmartDialog'
import TaskListSorting from '../../parts/TaskListSorting'
import createDialogTitle from '../../../generic/utilities/dialogUtil'
import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'
import { Sort } from '@mui/icons-material'

const TaskSortDialog = ({ open, setOpen, taskList, onSorted }) => {
  const { t_ } = useSmartTranslation()
  const [sortedItems, setSortedItems] = useState([])

  useEffect(() => {
    if (!taskList) {
      setSortedItems([])
      return
    }
    setSortedItems([...taskList])
  }, [taskList])

  const handleSortingChange = (items) => {
    const reordered = items.map((item, index) => ({
      ...item,
      taskOrder: index + 1
    }))
    setSortedItems(reordered)
  }

  return (
    <SmartDialog
      setOpen={open}
      acceptCallback={() => onSorted(sortedItems)}
      cancelCallback={() => setOpen(false)}
      title={createDialogTitle({ title: t_('Order tasks'), icon: Sort })}
      renderComponent={
        <TaskListSorting
          taskList={sortedItems}
          sortingChange={handleSortingChange}
        />
        }
    />
  )
}

export default TaskSortDialog
